import { render, staticRenderFns } from "./DonationTableItem.vue?vue&type=template&id=13d9cb40&scoped=true"
import script from "./DonationTableItem.vue?vue&type=script&lang=js"
export * from "./DonationTableItem.vue?vue&type=script&lang=js"
import style0 from "./DonationTableItem.vue?vue&type=style&index=0&id=13d9cb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d9cb40",
  null
  
)

export default component.exports